import {taskServices} from "../services/TaskServices";
import {formConstants} from "../constants/FormConstants";
import {history} from "../app/History";
import {routeConstants} from "../constants/RouteConstants";

export const taskActions = {
    addTask,
    updateTask,
};

function addTask(params, prefix = '') {
    return dispatch => {
        taskServices.setPrefix(prefix).add(params)
            .then(response => taskHandler(response, dispatch, prefix))
            .catch(() => {
                dispatch({type: formConstants.FORM_ERROR, message: "Ошибка сервера"})
            });
    }
}

function updateTask(id, params, prefix = '') {
    return dispatch => {
        taskServices.setPrefix(prefix).update(id, params)
            .then(response => taskHandler(response, dispatch, prefix))
            .catch(() => {
                dispatch({type: formConstants.FORM_ERROR, message: "Ошибка сервера"})
            });
    }
}

let taskHandler = (response, dispatch, prefix) => {
    if (response.status === 200) {
        const result = response.data;
        if (result.status === "error") {
            dispatch({type: formConstants.FORM_ERROR, message: result.message})
        } else {
            dispatch({type: formConstants.FORM_SENT, message: "Successful"});
            if (prefix === 'mo') {
                history.push(routeConstants.MOSREG_TASKS);
            } else if (prefix === 'eat') {
                history.push(routeConstants.EAT_TASKS);
            } else {
                history.push(routeConstants.MOS_TASKS);
            }
        }
    } else {
        dispatch({type: formConstants.FORM_ERROR, message: "Ошибка сервера"})
    }
};